"use client"

import { useState } from "react"
import "./Grupo_trabajo.css"

// Importación de imágenes locales (ahora con marcadores de posición generados)
import imagen1 from "../../assets/camilo.webp"
import imagen2 from "../../assets/dyd_1.webp"
import imagen3 from "../../assets/dyd_2.webp"
import imagen4 from "../../assets/dyd_100.webp"
import imagen6 from "../../assets/dyd_3.webp"


const TeamHoverCards = () => {
  const [selectedPerson, setSelectedPerson] = useState(null)

  // Datos del equipo organizados con identificadores únicos
  const teamMembers = {
    1: {
      name: "Sebastian Segura",
      position: "Gerente de Operaciones",
      description: `Soy Sebastián Segura, el Gerente de Operaciones de esta compañía, y estoy entusiasmado de presentarte mi perfil. Como ingeniero mecánico con una sólida especialización en gerencia de proyectos y actualmente candidato a magíster en investigación por la prestigiosa Universidad Nacional de Colombia, aporto más de cinco años de valiosa experiencia liderando y ejecutando proyectos de inversión con un enfoque inquebrantable en el éxito. Mi pericia se extiende también al sector inmobiliario, donde he demostrado una capacidad excepcional en la administración de propiedad horizontal y locales comerciales. Me considero una persona con carisma natural, proactiva y una atención meticulosa al detalle. Mi principal interés es lograr resultados sobresalientes, impulsando a mi equipo y a cada proyecto hacia la excelencia. Confío en mi liderazgo para llevar tus iniciativas al siguiente nivel y estoy listo para trabajar contigo.`,
      email: "gerencia.juridica@defensafinanciera.com.co",
      image: imagen2,
    },
    2: {
      name: "Daniela Giraldo Pino",
      position: "Gerente Jurídica",
      description: `Con más de 6 años de experiencia en el ámbito corporativo y comercial, soy una abogada especializada en Derecho Contractual, Legislación Mercantil y Financiera. Mi trayectoria se distingue por una sólida asesoría y representación judicial, enfocada en la estructuración y negociación de contratos, la gestión eficiente de riesgos legales y el cumplimiento normativo. He representado eficazmente a clientes en litigios y procedimientos administrativos en áreas clave como el derecho civil, comercial y laboral. Mi compromiso se extiende a la redacción precisa de documentos legales, asegurando el riguroso cumplimiento de los procedimientos judiciales. Ofrezco asesoramiento especializado a corporaciones en materias contractuales y de cumplimiento, elevando su seguridad jurídica. Además, sobresalgo en la gestión legal proactiva para la recuperación de recursos financieros, a través de la elaboración estratégica de Derechos de Petición, Tutelas e Impugnaciones, siempre con la máxima prioridad en los intereses de mis clientes.`,
      email: "gerencia.juridica@defensafinanciera.com.co",
      phone: "3175789585",
      image: imagen3,
    },
    
    
    3: {
      name: "Juan Camilo Santofimio",
      position: "Asesor",
      description: `Abogado Especialista en Derecho Administrativo y en Contratación Pública; candidato a Magíster en Derecho Administrativo. con 10 años de trayectoria asesorando entidades públicas en planeación jurídica, contratación estatal y gestión del riesgo legal. Experiencia litigiosa para firmas privadas en responsabilidad civil y derecho de seguros, con enfoque en prevención de contingencias y defensa judicial estratégica. Combino rigor técnico, comunicación persuasiva y liderazgo orientado a resultados para estructurar soluciones viables, medibles y sostenibles, integrando criterios de gobernanza, transparencia y eficiencia administrativa.`,
      email: "juancamilo@defensafinanciera.com.co",
      phone: "3117452143",
      image: imagen1,
    },
    4: {
      name: "Sandra Perez",
      position: "Asesora",
      description: `Brindo asesoría especializada en la identificación, gestión y recuperación de recursos inactivos dentro del sistema financiero, tanto a personas naturales como jurídicas. Implemento estrategias efectivas para contactar y acompañar a los clientes en la solicitud de devolución de recursos ante entidades bancarias y organismos de control; garantizando el cumplimiento normativo y preservando la confidencialidad y seguridad de la información del cliente durante todo el proceso.`,
      email: "sandra.perez@defensafinanciera.com.co",
      phone: "3156292241",
      image: imagen4,
    },

    6: {
      name: "Carolina Buitrago",
      position: "Asesora",
      description: `Abogada especializada en Legislación Tributaria y Aduanera, con experiencia en recuperación de cartera, negociación de saldos financieros y gestión jurídica integral. He liderado equipos y procesos administrativos en el sector público y privado, con enfoque en resultados, eficiencia operativa y cumplimiento normativo. Alta capacidad de análisis, resolución de conflictos y orientación estratégica al cliente.`,
      email: "carolina.buitrago@defensafinanciera.com.co",
      phone: "3176160498",
      image: imagen6,
    },
  }

  const handleOpenModal = (personId) => {
    setSelectedPerson(personId)
  }

  const handleCloseModal = () => {
    setSelectedPerson(null)
  }

  // Función para manejar el contacto por WhatsApp
  const handleGoContact = () => {
    const phoneNumber = "573175789585"
    const defaultMessage = "Hola, estoy interesado en recibir asesoría legal."
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`
    window.open(whatsappUrl, "_blank")
  }

  const currentMember = selectedPerson ? teamMembers[selectedPerson] : null

  return (
    <>
      <div className="team-container">
        <h2 className="team-title">Nuestro Equipo</h2>
        <div className="team-grid">
          {Object.entries(teamMembers).map(([id, member]) => (
            <div key={id} className="team-member" onClick={() => handleOpenModal(Number.parseInt(id))}>
              <div className="member-image-container">
                <img src={member.image || "/placeholder.svg"} alt={member.name} className="member-image" />
                <div className="card-overlay">
                  <div className="card-info">
                    <h3>{member.name}</h3>
                    <p>{member.position}</p>
                    <button
                      className="modern-button"
                      onClick={(e) => {
                        e.stopPropagation() // Evita que el modal se abra al hacer clic en el botón
                        handleOpenModal(Number.parseInt(id))
                      }}
                    >
                      Conoce más de mí
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action Section */}
        <section className="cta-section">
          <div className="cta-content">
            <h3>¿Necesita Asesoría Legal?</h3>
            <p>Contáctenos hoy mismo para una consulta personalizada</p>
            <button
              className="cta-button"
              onClick={handleGoContact}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)"
                e.target.style.boxShadow = "0 6px 20px rgba(255, 255, 255, 0.3)"
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)"
                e.target.style.boxShadow = "0 4px 12px rgba(255, 255, 255, 0.2)"
              }}
            >
              Contáctenos Ahora
            </button>
          </div>
        </section>
      </div>

      {/* Modal */}
      {currentMember && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleCloseModal}>
              ×
            </button>
            <div className="modal-layout">
              <div className="modal-image-section">
                <img src={currentMember.image || "/placeholder.svg"} alt={currentMember.name} className="modal-image" />
              </div>
              <div className="modal-text-section">
                <div className="modal-text-content">
                  <h2 className="modal-name">{currentMember.name}</h2>
                  <div className="modal-position-container">
                    <span className="modal-position">{currentMember.position}</span>
                  </div>
                  <div className="modal-divider"></div>
                  <div className="modal-description-container">
                    <p className="modal-description">{currentMember.description}</p>
                  </div>
                  {/* Información de contacto */}
                  {(currentMember.email || currentMember.phone) && (
                    <div className="modal-contact-info">
                      {currentMember.email && (
                        <p>
                          <strong>Correo:</strong> {currentMember.email}
                        </p>
                      )}
                      {currentMember.phone && (
                        <p>
                          <strong>Cel:</strong> {currentMember.phone}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default TeamHoverCards
